













































































import { computed, defineComponent } from '@vue/composition-api';
import GoalCardItem from '@/modules/ees/pages/learner-home/components/GoalCardItem.vue';
import GoalInputAdd from '@/modules/ees/pages/learner-home/components/GoalInputAdd.vue';
import GoalHistory from '@/modules/ees/pages/learner-home/components/GoalHistory.vue';
import { LearnerGoalsStoreKey } from '@/store/StoreInjectionKeys';
import { injectStrict } from '@/lib/utils';
import TodaysMeetingsCards from '@/modules/ees/components/TodaysMeetingsCards.vue';
import { LearnerStoreKey } from '@/store/StoreInjectionKeys';

export default defineComponent({
  name: 'LearnerHome',
  components:{
    GoalCardItem,
    GoalInputAdd,
    GoalHistory,
    TodaysMeetingsCards
  },
  setup() {
    const learnerGoalsStore = injectStrict(LearnerGoalsStoreKey);
    const learnerStore = injectStrict(LearnerStoreKey);

    learnerGoalsStore.actions.getGoals();
    learnerStore.actions.getCurrentYearStatus();
    learnerStore.actions.getLearnerGrowthSummary();

    const growthSummary = computed(() => learnerStore.state.learnerGrowthSummary);
    const growthFiscalYear = computed(() => {
      if (!growthSummary.value) {
        return '';
      }
      return String(growthSummary.value.fiscalYear + 1990);
    });
    const formatGrowthValue = (value?: number) => {
      if (value === undefined || value === null) {
        return 'N/A';
      }
      return value.toFixed(2);
    };

    return {
      learnerGoalsStore,
      learnerStore,
      growthSummary,
      growthFiscalYear,
      formatGrowthValue
    }
  }
})
